/*  */
import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { css } from '@emotion/react';
import { breakpoints } from '@vfit/shared/themes';

export const Container = styled.div<{
  disableMarginTop?: boolean;
  isApp?: boolean;
  iconSize?: number;
}>`
  margin-top: ${({ disableMarginTop }) => `${disableMarginTop ? '0' : '50px'}`};
  padding: 40px ${theme.spacing.lg} ${theme.spacing.xl};
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.colors.brand.primaryDisabled};
  border-radius: ${({ isApp }) => `${isApp ? '6px' : '20px'}`};
  background-color: ${theme.colors.text.inverse};
  // min-height: 333px;

  .bottom-container-card-info {
    position: relative;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
  }

  .wrapperIcon {
    width: ${(props) => `${props.iconSize ? props.iconSize : 50}px`};
    height: ${(props) => `${props.iconSize ? props.iconSize : 50}px`};
  }

  svg {
    width: 100%;
  }

  .numberBox {
    margin: 0;
    font-family: ${theme.typography.fontFamily.secondary};
    font-weight: ${theme.typography.fontWeight.light};

    font-size: ${theme.typography.fontSize.h1};
    line-height: ${theme.typography.lineHeight.h4};
    color: ${theme.colors.brand.primary};

    @media (min-width: ${breakpoints.tablet}) {
      font-size: ${theme.typography.fontSize.h1};
      line-height: ${theme.typography.lineHeight.h1};
    }

    @media (min-width: ${breakpoints.desktop}) {
      font-size: ${theme.typography.fontSize.display1};
      line-height: ${theme.typography.lineHeight.display1};
    }
  }
`;

export const Title = styled.p<{
  type: string;
  areIconsAndNumbersHidden: boolean;
}>`
  margin: 0;
  margin-top: ${({ areIconsAndNumbersHidden }) =>
    areIconsAndNumbersHidden ? 0 : theme.spacing.lg};

  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h6};

  ${media.tablet`
    font-size: ${theme.typography.fontSize.h5};
    line-height: ${theme.typography.lineHeight.h6};
  `}

  ${media.desktop`
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.h2};

    margin-top: ${({ areIconsAndNumbersHidden, type }) =>
      areIconsAndNumbersHidden ? 0 : type === 'number' ? theme.spacing.md : theme.spacing.lg};
  `}
`;

export const TextContainer = styled.div`
  div {
    margin: 0;
    margin-top: ${theme.spacing.lg};
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${theme.typography.lineHeight.body1};
    color: ${theme.colors.text.primary};
  }

  ${media.desktop`
    div {
      
      margin-top: ${theme.spacing.lg};
      font-size:${theme.typography.fontSize.h6};
      line-height:${theme.typography.lineHeight.h6};
    }
  `}
`;

export const FrontLabel = styled.div`
  font-family: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
  color: ${theme.colors.text.primary};
`;

export const ButtonContainer = styled.div`
  .capitalize-first {
    text-transform: lowercase;
  }
  .capitalize-first::first-letter {
    text-transform: uppercase;
  }
  text-align: center;
  margin-top: 20px;
  width: 100%;
  button,
  a {
    margin: 0 auto;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      display: block;
    }
  }
  white-space: nowrap;
`;

const commonRichTextStyles = css`
  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.link};
    }
  }

  button {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
    font-size: ${theme.typography.fontSize.display5};

    color: ${theme.colors.text.brand};
    background: none;
    border: none;
    padding: 0;
    outline: inherit;

    span {
      font-family: ${theme.typography.fontFamily.secondary};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.inverse};
      background-color: ${theme.colors.brand.primary};
      padding-left: ${theme.spacing.sm};
      padding-right: ${theme.spacing.sm};
      border-radius: 50%;
      cursor: pointer;
    }

    &:hover {
      span {
        background-color: ${theme.colors.text.linkHover};
      }
    }

    &:active {
      span {
        background-color: ${theme.colors.interactive.active};
      }
    }
  }
`;
export const DescriptionText = styled.div`
  ${commonRichTextStyles}
  margin: 0;
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.light};
  font-size: ${theme.typography.fontSize.h6};
  line-height: ${theme.typography.lineHeight.h6};
  margin: 48px 23px 31px 23px;
`;
